import i1 from '../img/i1.png'
import f1 from '../img/f1.png'
import c3 from '../img/c3.png'
import fi1 from '../img/fi1.png'

export const heroData = [
    {
        id:1,
        name: 'Ice Cream',
        description: 'Chocolate & Vanilla',
        price: '5.25',
        imageUrl: i1
    },
    {
        id:2,
        name: 'Strawberries',
        description: 'Fresh Strawberries',
        price: '10.25',
        imageUrl: f1
    },
    {
        id:3,
        name: 'Chicken Kebab',
        description: 'Mixed Kebab Plate',
        price: '8.25',
        imageUrl: c3
    },
    {
        id:4,
        name: 'Fish Kebab',
        description: 'Mixed Fish Kebab',
        price: '5.25',
        imageUrl: fi1
    },
]

export const categories = [
    {
      id: 1,
      name: "Chicken",
      urlParamName: "chicken",
    },
    {
      id: 2,
      name: "Curry",
      urlParamName: "curry",
    },
    {
      id: 3,
      name: "Rice",
      urlParamName: "rice",
    },
    {
      id: 4,
      name: "Fish",
      urlParamName: "fish",
    },
    {
      id: 5,
      name: "Fruits",
      urlParamName: "fruits",
    },
    {
      id: 6,
      name: "Icecreams",
      urlParamName: "icecreams",
    },
  
    {
      id: 7,
      name: "Soft Drinks",
      urlParamName: "drinks",
    },
  ];